import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

/**
 * Auto-open a modal for a specific item when the URL carries `?open=<id>`.
 *
 * Used by the HUB reference cards in Team Chat so that clicking
 * "Apri capo" jumps straight into the item's edit modal on the target page
 * instead of stopping at the list view.
 *
 * @param {Array<{id:string}>} list  - the loaded list of items on the page
 * @param {(row:object) => void} open - the page's existing modal opener
 * @param {string} [param="open"] - override the query param name
 */
export function useAutoOpenFromQuery(list, open, param = "open") {
  const loc = useLocation();
  const openedRef = useRef(null);

  useEffect(() => {
    if (!Array.isArray(list) || list.length === 0) return;
    if (typeof open !== "function") return;
    const id = new URLSearchParams(loc.search).get(param);
    if (!id || openedRef.current === id) return;
    const row = list.find((x) => x && x.id === id);
    if (row) {
      openedRef.current = id;
      open(row);
    }
  }, [list, loc.search, open, param]);
}
